export default [
  {
    info: '广州开发区第一幼儿园 **乐参赛成功'
  },
  {
    info: '深圳小学**一善参赛成功'
  },
  {
    info: '青岛市市南区嘉峪关小学**贝参赛成功'
  },
  {
    info: '重庆市人民小学**语参赛成功'
  },
  {
    info: '北京师范大学附属小学**杰参赛成功'
  },
  {
    info: '深圳实验幼儿园**梓墨参赛成功'
  },
  {
    info: '宁波艾毅实验幼儿园**浩辰参赛成功'
  },
  {
    info: '苏州市平江实验学校**Berry参赛成功'
  },
  {
    info: 'Heritage School **KevinWu参赛成功'
  },
  {
    info: '北京市南希双语幼儿园**天宝参赛成功'
  },
  {
    info: '青岛市市南区嘉峪关小学**小婵参赛成功'
  },
  {
    info: '八十中实验学校**一鸣参赛成功'
  },
  {
    info: '北京第二实验小学**小甜参赛成功'
  },
  {
    info: '上海协和双语学校**罗参赛成功'
  },
  {
    info: '上海福山外国语小学**Erica参赛成功'
  },
  {
    info: '北京市朝阳区星河实验小学**豪参赛成功'
  },
  {
    info: '合肥市和平小学东校**成如参赛成功'
  },
  {
    info: '福州市华南实验小学**江涛参赛成功'
  },
  {
    info: '厦门第二实验小学**意轩参赛成功'
  },
  {
    info: '长沙市砂子塘小学**来福参赛成功'
  },
  {
    info: '长沙华夏实验小学**若涵参赛成功'
  },
  {
    info: '东莞市凤岗金凤凰小学**雅柔参赛成功'
  },
  {
    info: '广州海珠区实验小学**斌参赛成功'
  },
  {
    info: '长春市南关区明珠小学**佳颖参赛成功'
  },
  {
    info: '吉林省第二实验小学**婷婷参赛成功'
  }
]
